import * as React from "react";
const SvgCompilation = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23.91 25.19",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "compilation_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "compilation_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M19 0H2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6.39a1 1 0 0 0 1-1 1 1 0 0 0-1-1H2V2h17v8a1 1 0 0 0 1 1 1 1 0 0 0 1-1V2a2 2 0 0 0-2-2",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16 7a1.05 1.05 0 0 1-1.1 1H6.1A1.06 1.06 0 0 1 5 7a1.06 1.06 0 0 1 1.1-1h8.8A1.05 1.05 0 0 1 16 7M9.67 15a1.13 1.13 0 0 1-.28.77.67.67 0 0 1-.49.23H5.78A.91.91 0 0 1 5 15a.91.91 0 0 1 .78-1H8.9a.67.67 0 0 1 .49.23 1.13 1.13 0 0 1 .28.77M21.91 13.57a6.81 6.81 0 1 0 0 9.63 6.81 6.81 0 0 0 0-9.63m-8.51 8.51a5.23 5.23 0 1 1 7.39 0 5.22 5.22 0 0 1-7.39 0",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m20.76 17-4.33 4.33a.86.86 0 0 1-1.2 0L13 19.19A.86.86 0 0 1 14.23 18l1.61 1.61 3.74-3.74A.83.83 0 1 1 20.76 17M13.78 11a1 1 0 0 1-.88 1h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 .88 1",
	style: { fill: "currentColor" }
}))));
export default SvgCompilation;
